<button class="btn btn-primary test" (click)="click()">алерт</button>
